import { Component, Input, OnChanges } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'app-header-one',
    templateUrl: './header_1.component.html',
    styleUrls: ['./header_1.component.less'],
    standalone: false
})
export class HeaderOneComponent implements OnChanges {
  @Input() type;
  @Input() title;
  @Input() subTitle;
  @Input() date;
  @Input() color;
  @Input() textColor;

  public opacityColor;
  public _date;
  constructor() {}

  ngOnChanges() {
    this.opacityColor = this.hexToRGB(this.color, 0.8);
    if (this.date) {
      this._date = moment(this.date, 'DD.MM.YYYY').format('DD. MMM');
    } else {
      this._date = '';
    }
    if (this.type && this.type === 'blog') {
      this._date = this.date;
      this.title = moment(+this.title).format('DD.MM.YYYY - HH:mm');
    }
  }

  hexToRGB(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }
}
